import { render } from "./ModalPasswordChange.vue?vue&type=template&id=f7bcf8ba&scoped=true"
import script from "./ModalPasswordChange.vue?vue&type=script&lang=js"
export * from "./ModalPasswordChange.vue?vue&type=script&lang=js"

import "./ModalPasswordChange.vue?vue&type=style&index=0&id=f7bcf8ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bcf8ba"]])

export default __exports__